import { useLoaderData, useNavigate } from "react-router-dom";
import Cup from "../../components/Cup";
import Button from "../../../shared/components/Button/Button";
import { useLayoutEffect, useState, useEffect } from "react";
import SmallPop from "../../../shared/components/pops/SmallPop";
import { isMobile } from "react-device-detect";
import { toPng } from "html-to-image";
import { doc, getDoc } from "firebase/firestore";
import { useFirebase } from "../../../contexts/FirebaseContext";
import "../../../shared/pages/Browse/SharedBrowse.css";
import "./WorldBrowse.css";

import { ReactComponent as UserIcon } from "../../../assets/icons/svg/user-svgrepo-com.svg";
import { ReactComponent as ShareIcon } from "../../../assets/icons/svg/share-svgrepo-com.svg";
import { ReactComponent as DownloadIcon } from "../../../assets/icons/svg/download-minimalistic-svgrepo-com.svg";

export default function WorldBrowseCupId() {
    const data = useLoaderData();
    const navigate = useNavigate();
    const { firestore } = useFirebase();
    const [smallPop, setSmallPop] = useState();
    const [currentCreatorName, setCurrentCreatorName] = useState(data?.creator);

    // Fetch current displayName from Firestore to handle username changes
    useEffect(() => {
        const fetchCurrentCreatorName = async () => {
            if (data?.creatorId) {
                const userDoc = await getDoc(doc(firestore, "users", data.creatorId));
                if (userDoc.exists()) {
                    setCurrentCreatorName(userDoc.data().displayName);
                }
            }
        };
        fetchCurrentCreatorName();
    }, [data?.creatorId, firestore]);

    console.log(data)

    useLayoutEffect(() => {
        if (smallPop) {
            const timeout = setTimeout(() => {
                setSmallPop(null);
            }, 3500);
            return () => clearTimeout(timeout);
        }
    }, [smallPop]);

    return (
        <div id="main-container">
            <div id="found-cup-container" className="cup-card">
                {data?.tracks.length > 0 && (
                    <>
                        <div className="cup-header">
                            <h3>{data?.cupName || "Untitled Cup"}</h3>
                            <Button
                                text={currentCreatorName || "Unknown Creator"}
                                icon={UserIcon}
                                variant="world"
                                color="blue"
                                onClick={() => navigate(`/profile/${currentCreatorName}`, { state: { from: 'world' } })}
                            />
                        </div>

                        <div id="cup-container">
                            <Cup tracks={data?.tracks} />

                            <p>Track List</p>
                            <ul style={{ color: "white" }}>
                                {data?.trackList?.map((trackStr, index) => (
                                    <li key={index}>{trackStr}</li>
                                ))}
                            </ul>
                        </div>

                        <div className="share-actions">
                            <Button
                                text="Share"
                                icon={ShareIcon}
                                disabled={!data?.id}
                                onClick={(e) => {
                                    e.preventDefault();
                                    navigator.clipboard.writeText(
                                        `https://mk8dx-cup-builder.web.app/browse/cup/${data?.id}`
                                    );
                                    setSmallPop(true);
                                }}
                            />

                            {!isMobile && (
                                <Button
                                    text="Download Cup Image"
                                    icon={DownloadIcon}
                                    onClick={() => {
                                        toPng(document.getElementById("cup-container"))
                                            .then((dataUrl) => {
                                                const link = document.createElement("a");
                                                link.download = `${data?.cupName || "World Cup"}.png`;
                                                link.href = dataUrl;
                                                link.click();
                                            });
                                    }}
                                />
                            )}
                        </div>
                    </>
                )}

                {smallPop && <SmallPop text="Copied URL to clipboard!" onClose={() => setSmallPop(null)} />}
            </div>
        </div >
    );
}
